import { useEffect, useState } from 'react';
import { CardItem, TestimonialsCardContainer } from './styles';
import { Pagination } from "swiper";

interface Card {
    id: number,
    name: string,
    description: string,
    image: string
}

export function TestimonialsCard() {
    const [listCard, setListCard] = useState<Card[]>([])

    useEffect(() => {
        fetch('./services/testimonials.json', {
            headers: {
                Accept: 'application/json'
            }
        }).then(response => response.json())
            .then(data => setListCard(data.testimonial))
    }, [])
    return (
        <TestimonialsCardContainer
            loop={true}
            spaceBetween={24}
            grabCursor={true}
            pagination={
                {
                    clickable: true,
                }
            }
            breakpoints={{
                "@0.00": {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                "0.50": {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                "@1.00": {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
            }}
            modules={[Pagination]}
        >
            {listCard.map((card) => {
                let formatedCardDescription = card.description.slice(0,190);
                if(card.description.length > 190){
                    formatedCardDescription = formatedCardDescription + "..."
                }
                return (
                    <CardItem key={card.id}>
                        <img src={card.image} alt={card.name} />
                        <h3>{card.name}</h3>
                        <p>{formatedCardDescription}</p>
                    </CardItem>
                )
            })}
        </TestimonialsCardContainer>
    )
}